import { Component, input, output, computed, TemplateRef } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { ZnButton } from '../zn-button/zn-button';
import { HeaderMode } from './enums/HeaderMode';
import { LayoutList } from '../layout-list/layout-list';

import { ZendraLocalizationServices } from '../enums/abpLocalizationServices';
import { IGridLayout } from '../layout-list/interface/IGridSnapshot';
import { ZendraLocalizationPipe } from '../pipes/zendra-localization.pipe';
import { IActionsSchema } from '../zn-other-actions/interfaces/IAction';
import { ZnOtherActions } from '../zn-other-actions/zn-other-actions';

@Component({
  selector: 'app-table-header',
  imports: [NgTemplateOutlet, ZnButton, LayoutList, ZendraLocalizationPipe, ZnOtherActions],
  templateUrl: './table-header.html',
  styleUrl: './table-header.scss'
})
export class TableHeader {
  tableName = input('');
  subtitleTemplate = input<TemplateRef<unknown> | null>(null);
  actionsTemplate = input<TemplateRef<unknown> | null>(null);
  activeMode = input(HeaderMode.Idle);
  disable = input(false);
  selectedItems = input(0);
  
  //Other Actions
  actions = input<IActionsSchema | null>(null);
  selectedRecords = input<any[]>([]);

  // Permissions
  canCreate = input(false);
  canEdit = input(false);
  canDelete = input(false);
  disableDuplicate = input(false);

  createRecord = output();
  deleteRecord = output();
  exportToExcelRecord = output();
  duplicateRecord = output();
  summaryRecord = output();
  saveRecord = output();
  cancelRecord = output();
  layoutChange = output<IGridLayout>();

  headerMode = HeaderMode;
  localizationResource = ZendraLocalizationServices;

  onCreateRecord() {
    this.createRecord.emit();
  }

  onDeleteRecord() {
    this.deleteRecord.emit();
  }

  onDuplicateRecord() {
    this.duplicateRecord.emit();
  }

  onSummaryRecord() {
    this.summaryRecord.emit();
  }

  onSaveRecord() {
    this.saveRecord.emit();
  }

  onCancelRecord() {
    this.cancelRecord.emit();
  }

  onExportToExcelRecord() {
    this.exportToExcelRecord.emit()
  }

  onLayoutChange(layout: IGridLayout) {
    this.layoutChange.emit(layout);
  }

  showHeaderRow = computed(() => {
    const mode = this.activeMode();
    const hasActions =
      !!this.actions()?.overTable?.length ||
      !!this.actions()?.multipleRecord?.length ||
      !!this.actions()?.singleRecord?.length;

    switch (mode) {
      case HeaderMode.Selection:
        return (
          this.selectedItems() > 0 ||
          this.canDelete() ||
          this.canCreate() ||
          hasActions
        );

      case HeaderMode.Edit:
      case HeaderMode.Duplication:
        return true;

      default:
        return hasActions;
    }
  });
}
